import { Component, Input, OnInit } from '@angular/core';
import { IParceiroContato } from '@app/modules/parceiro/model';
import {
  IConsultaPredictusPessoaFisica,
  MOCK_PESSOA_FISICA
} from '@app/modules/parceiro/model/consulta_predictus_pf.model';

@Component({
  selector: 'info-predictus-pf',
  templateUrl: './info-predictus-pf.component.html',
  styleUrl: './info-predictus-pf.component.scss'
})
export class InfoPredictusPfComponent implements OnInit {
  @Input() pessoaFisica = MOCK_PESSOA_FISICA as IConsultaPredictusPessoaFisica;

  ngOnInit() {
    this.pessoaFisica.contatos = this.pessoaFisica.contatos
      .concat(
        this.pessoaFisica.telefones.map((tel, index) => {
          return {
            contato: tel.numero ? tel.numero : tel,
            tag: `telefone_${index + 1}`
          } as IParceiroContato;
        })
      )
      .concat(
        this.pessoaFisica.emails.map((mail, index) => {
          return {
            contato: mail,
            tag: `email_${index + 1}`
          } as IParceiroContato;
        })
      );
  }

  getSexo(sexo: string) {
    if (sexo === 'M') return 'MASCULINO';
    else if (sexo === 'F') return 'FEMININO';
    else 'OUTROS';
  }

  /**
   * Formata uma tag para ser mostrada na view
   * @param tag tag a ser formatada
   */
  formatarTags(tag: string[]): string[] {
    if (typeof tag === 'object') return tag.filter(tg => tg !== '');
    else return tag;
  }
}
